import { useEffect } from "react";
import _isPlainObject from "lodash/isPlainObject";
import environment from "web/script/modules/environment";

interface FeaturesObject {
    [key: string]: string | boolean;
}
export function useCustomFeatures(features: FeaturesObject): void {
    useEffect(() => {
        if (_isPlainObject(features)) {
            environment.set({ features });
        }
    }, [features]);
}
